<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-dialog v-model="showDeleteModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Change Email Address</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showDeleteModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        Are you sure you want to change Account Email address?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark" small @click="showDeleteModal=false">
                            No
                        </v-btn>
                        <v-btn color="orange " class="white-text" small @click="changeEmailAddress">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout row wrap>
            <v-dialog v-model="phoneNoModal" persistent max-width="320px">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Change Phone Number</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="phoneNoModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-text-field v-validate="{required: true, numeric: 'phone_1', custom_contact: 'phone_1'}" :error-messages="errors.collect('phone_1')"  name="phone_1" label="Phone Number" v-model="phone_1" data-vv-as="Phone Number" :mask="`${contactNumberMaskForInput}`"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="gray white--text" small @click="phoneNoModal=false">
                            Cancel
                        </v-btn>
                        <v-btn color="green white--text" class="white-text" small @click="changePhoneNumber">
                            Save
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout row wrap>
            <v-dialog v-model="changePasswordModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Change Password</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="hideChangePasswordModal">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-form @submit.prevent="changePassword()" autocomplete="off">
                    <v-card-text>
                        <input autocomplete="false" name="hidden" type="text" style="display:none;">
                        <v-layout row wrap>
                            <v-flex lg12 md12 xs12 pos-relative>
                            <v-text-field :type="'password'"
                                label="Current Password *"
                                class="white-placeholder"
                                autocomplete="off"
                                v-model="form.current_password"
                                id="current_password"
                                data-vv-name="current_password"
                                data-vv-as="Current Password"
                                placeholder
                                v-validate="{required:true,'restrictedWord':[]}"
                                :error-messages="errors.collect('current_password')"
                            ></v-text-field>
                            <a class="forgot-password-link" @click="forgotPassword">Forgot Password?</a>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex lg12 md12 xs12>
                            <v-text-field :type="'password'"
                                label="New Password *"
                                class="white-placeholder"
                                autocomplete="off"
                                v-model="form.new_password"
                                id="new_password"
                                data-vv-name="new_password"
                                data-vv-as="New Password"
                                placeholder
                                v-validate="{'required':true,'min':8,'restrictedWord':[]}" ref="new_password"
                                :error-messages="errors.collect('new_password')"
                            ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex lg12 md12 xs12>
                            <v-text-field
                            label="Confirm New Password *"
                            data-vv-name="password_confirmation"
                            data-vv-as="Confirm New Password"
                            data-vv-delay="300"
                            v-validate="{'required':true,'confirmed':'new_password'}"
                            v-model="form.confirm_new_password"
                            :error-messages="errors.collect('password_confirmation')"
                            :type="'password'"
                            ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="gray white--text" small @click="hideChangePasswordModal">
                            Cancel
                        </v-btn>
                        <v-btn color="green white--text" class="white-text" type="submit" small>
                            Submit
                        </v-btn>
                    </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout row wrap>
            <v-dialog v-model="forgotPasswordModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title> Password</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        {{alertMsgForForgotPassword}}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green white--text" class="white-text" small @click="hideforgotPasswordModal">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout row wrap>
            <v-dialog v-model="showChangePlanModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Change Subscription</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showChangePlanModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="changePlanDialog">
                        {{changePlanInfoTxt}}
                        <ul>
                            <li>
                                <i class="fa fa-envelope"></i>
                                <a :href="`mailto:${defaultEmailAddress}`">
                                    {{defaultEmailAddress}}
                                </a>
                            </li>
                            <li> 
                                <i class="fa fa-phone"></i>
                                <a :href="`tel:${defaultContactNumber}`">
                                    {{defaultContactNumber}}
                                </a>
                            </li>
                        </ul>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="orange" class="white-text" small @click="showChangePlanModal=false">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout row wrap>
            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Account</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                       <v-container grid-list-xl fluid>
                            <v-layout row wrap v-if="userData.data">
                                <v-flex lg4 md6 xs12>
                                    <h4>MEMBERSHIP</h4>
                                </v-flex>
                                <v-flex lg8 md6 xs12>
                                    <v-layout row wrap>
                                        <v-flex lg6 md6 xs12>
                                        <v-divider class="hidden-sm-and-up"></v-divider>
                                            <b>{{userData.data.data.User.email}}</b>
                                        </v-flex>
                                        <v-flex lg6 md6 xs12 text-xs-right>
                                            <a target="_blank"  class="link-text" @click="showDeleteModal=true">Change Email</a>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg6 md6 xs12>
                                         <v-divider class="hidden-sm-and-up"></v-divider>
                                            Password: {{defaultPasswordSymbol}}                                                 
                                        </v-flex>
                                        <v-flex lg6 md6 xs12 text-xs-right>
                                            <a target="_blank" @click="changePasswordModal=true" class="link-text">Change Password</a>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg6 md6 xs12>
                                            <v-divider class="hidden-sm-and-up"></v-divider>
                                            Phone: {{userData.data.data.User.UserContacts.phone_1 | phone}} 
                                        </v-flex>
                                        <v-flex lg6 md6 xs12 text-xs-right>
                                            <a target="_blank" @click="phoneNoModal=true" class="link-text">Change Phone Number</a>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                       </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-container grid-list-xl fluid>
                            <v-layout row wrap v-if="userData.data">
                                <v-flex lg4 md6 xs12>
                                    <h4>SUBSCRIPTION</h4>
                                </v-flex>
                                <v-flex lg8 md6 xs12>
                                    <v-layout row wrap>
                                        <v-flex lg6 md6 xs12>
                                            <template v-if="userData.data.data.User.UserRoles && userData.data.data.User.UserRoles.length>0">
                                                <span v-for="(role,index) in userData.data.data.User.UserRoles" :key="index">
                                                    <v-chip v-if="role.Role.name && role.Role.name != ''">
                                                        {{utils.getTitleCase(role.Role.name)}}
                                                    </v-chip>
                                                </span>
                                            </template>
                                            <template v-else>
                                                {{notProvidedStr}}
                                            </template>                                             
                                        </v-flex>
                                        <v-flex lg6 md6 xs12 text-xs-right>
                                            <a target="_blank" class="link-text" @click="showChangePlanModal=true">Change Subscription</a>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                       </v-container>
                    </v-card-text>  
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                       <v-container grid-list-xl fluid>
                            <v-layout row wrap v-if="userData.data">
                                <v-flex lg4 md6 xs12>
                                    <h4>MY PROFILE</h4>
                                </v-flex>
                                <v-flex lg8 md6 xs12>
                                    <v-layout row wrap>
                                        <v-flex lg6 md6 xs12>
                                          <v-divider class="hidden-sm-and-up"></v-divider>
                                            {{utils.getTitleCase(userData.data.data.User.UserContacts.first_name)}} {{utils.getTitleCase(userData.data.data.User.UserContacts.last_name)}}
                                        </v-flex>
                                        <v-flex lg6 md6 xs12 text-xs-right>
                                            <router-link class="link-text" :to="{name: 'PROFILE',query:{e:1}}">Manage Profile</router-link>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>
<script>
import services from "../services/HttpService";
import axios from "axios";
import { Validator } from 'vee-validate';
import config from "../config";
import utils from "../util";
import GoogleAds from "@/pages/widgets/GoogleAds";
import {
    mapGetters,
    mapActions
} from "vuex";
import store from '../store/';
export default {
    $_veeValidate: {
        validator: 'new'
    },
    components:{
        GoogleAds
    },
    data: () => ({
        defaultPasswordSymbol:config.defaultPasswordSymbol,
        notProvidedStr:config.notProvidedStr,
        userData: {},
        showDeleteModal: false,
        phoneNoModal: false,
        phone_1: '',
        contactNumberMaskForInput:config.contactNumberMaskForInput,
        changePasswordModal: false,
        forgotPasswordModal: false,
        alertMsgForForgotPassword: config.alertMsgForForgotPassword,
        showChangePlanModal: false,
        form: {
            current_password: '',
            new_password: '',
            confirm_new_password: ''
        },
        changePlanInfoTxt:config.changePlanInfoTxt,
        defaultEmailAddress: config.defaultEmailAddress,
        defaultContactNumber: config.defaultContactNumber,
        defaultAddress: config.defaultAddress
    }),
    mounted() {
        const self = this;
        self.$validator.localize('en', self.dictionary);
    },
    created() {
        const self = this,
            wApp = window.getApp;
            self.utils = utils;
        wApp.$emit("showLoader", {
            show: true
        });
        axios.all([
                services.post("users/userListById", {
                    uuid: self.$store.state.user.uuid
                }, {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                })
            ])
            .then(axios.spread(function (users) {
                self.userData = Object.assign({}, users);
                self.utils.updateLoggedInUserInfo(store,users.data.data.User);
                self.phone_1 = self.userData.data.data.User.UserContacts.phone_1,
                wApp.$emit("showLoader", {
                    show: false
                });
            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
    },
    methods: {
        ...mapActions([
            "login",
        ]),
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        changeEmailAddress() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.showDeleteModal = false;
            services.post("users/update-user-email", {}, {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self._showToast(res.data.message,config.successMsgColorStr);
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        changePhoneNumber() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.phoneNoModal = false;
            const formData = {};
            formData.uuid = self.$store.state.user.uuid;
            formData.phone_1 = self.phone_1;
            services.put("users/edit", formData, {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self.userData.data.data.User.UserContacts.phone_1 = self.phone_1;
                    self._showToast(config.updatePhoneSuccessMsg,config.successMsgColorStr);
                    let newStoreUserObj = Object.assign({},self.$store.state.user);
                    newStoreUserObj.contact_phone_no = self.phone_1;
                    self.login({
                        user: newStoreUserObj
                    });
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        changePassword() {
            const self = this,
                wApp = window.getApp;
            self.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        self.changePasswordModal = false;
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        services.post("users/changeUserPassword", {
                            password: self.form.new_password,
                            old_password: self.form.current_password
                        },{"Authorization": "Bearer " + self.$store.state.user.token})
                        .then(res => {
                            wApp.$emit("showLoader", {
                                show: false
                            });
                            self.changePasswordFormReset();
                            if (res.data.status) {
                                self._showToast(res.data.message);
                            } else {
                                self._showToast(res.data.message, config.errMsgColorStr);
                            }
                        })
                        .catch(err => {
                            self.changePasswordFormReset();
                            self._showToast(err.message, config.errMsgColorStr);
                        });
                    }
                })
                .catch(e => {
                    wApp.$emit("showLoader", {
                    show: false
                });
                return false;
            });
        },
        hideChangePasswordModal(){
            const self = this;
            self.changePasswordModal = false;
            self.changePasswordFormReset();
        },
        changePasswordFormReset(){
            const self = this;
            self.form.current_password = "";
            self.form.new_password = "";
            self.form.confirm_new_password = "";
            self.$validator.reset();
        },
        forgotPassword(){
            const self = this,
                wApp = window.getApp;
            self.changePasswordModal = false;
            wApp.$emit("showLoader", {
                show: true
            });
            services.post("users/forgotPassword", {
                "email": self.$store.state.user.email
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self.changePasswordFormReset();
                if (res.data.status) {
                    self.forgotPasswordModal = true;
                } else {
                    self._showToast(res.data.message, config.errMsgColorStr);
                }
            })
            .catch(err => {
                self.changePasswordFormReset();
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        hideforgotPasswordModal(){
            const self = this;
            self.forgotPasswordModal = false;
            self.$store.dispatch('logout');
            let loginUrl = '/login';
            if(self.$store.state.loginType && self.$store.state.loginType != ''){
                loginUrl += '/'+self.$store.state.loginType;
            }
            self.$router.push(loginUrl);
        }
    }
};
</script>
<style>
.changePlanDialog ul{
    padding:15px 0 0 0; 
    margin: 0;
}
.changePlanDialog li{
    position: relative;
    padding-left:30px;
    list-style: none;
}
.changePlanDialog  i{
    position:absolute;
    top:5px;
    left:0px; 
    display: block;
    width: 20px;
    height: 20px;
    text-align: center;  
}
.changePlanDialog a{
    color: rgba(0,0,0,0.87);
}
a {
    text-decoration: none !important;
}
.forgot-password-link
{
    position: absolute;
    right: 0;
    top: 22px;
    color: #ff812b !important;
    font-size: 12px !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Account.vue